import { InfoBanner } from "@closer/ui";
import { useSyncExternalStore } from "react";

/**
 * ÇEVRİMDIŞI ŞERİDİ (CLOS-1278 · Readiness §5.9).
 *
 * ### ⚠ İki katmanın görünen yüzü
 *
 * Asıl kapı `lib/apiClient.ts`'te: çevrimdışıyken yazma isteği ağa hiç çıkmıyor. Bu şerit
 * o kararı GÖRÜNÜR kılıyor — kullanıcı butona basıp hata almadan önce neden yapamayacağını
 * biliyor. Yalnız kapı olsaydı davranış "sessizce reddediliyor" olurdu; yalnız şerit
 * olsaydı gözden kaçan her yüzey açık kalırdı.
 *
 * ### ⚠ `useSyncExternalStore` — `useState` + `useEffect` DEĞİL
 *
 * Bağlantı durumu React'in dışında yaşayan bir değer. `useEffect` ile kopyalasaydık ilk
 * render ile gerçek durum arasında bir kare fark olurdu: sayfa çevrimdışı açıldığında bir
 * an "her şey yolunda" görünürdü. Bu kanca değeri okuma anında alıyor.
 *
 * ### ⚠ Metin NE YAPILAMAYACAĞINI söylüyor
 *
 * Belge §5.10 her engelden üç cevap istiyor: ne oldu, neden yapamıyorum, ne yapmalıyım.
 * "Bir sorun oluştu" bunların hiçbirini vermez.
 */

/** ⚠ Sunucu tarafında (SSR/test öncesi) `navigator` yok; orada çevrimiçi varsayılıyor. */
function anlikDurum(): boolean {
  return typeof navigator === "undefined" || navigator.onLine !== false;
}

function aboneOl(yenile: () => void): () => void {
  globalThis.addEventListener("online", yenile);
  globalThis.addEventListener("offline", yenile);
  return () => {
    globalThis.removeEventListener("online", yenile);
    globalThis.removeEventListener("offline", yenile);
  };
}

export function BaglantiUyarisi() {
  const cevrimici = useSyncExternalStore(aboneOl, anlikDurum, () => true);

  if (cevrimici) return null;

  /**
   * ⚠ `role="status"` SARMALAYICIDA: `InfoBanner` bu prop'u almıyor ve tek bir kullanım
   * için UI kit'in arayüzünü genişletmek doğru olmazdı (kural 2 — bileşen paketin malı).
   * Ekran okuyucu için canlı bölge burada; görsel karar bileşende kalıyor.
   */
  return (
    <div role="status">
      <InfoBanner tone="warning" className="mb-4">
        <span>
          <strong>Bağlantı yok.</strong> Bağlantı dönene kadar değişiklik kaydedilemez; görüntülenen
          bilgiler güncel olmayabilir.
        </span>
      </InfoBanner>
    </div>
  );
}
